/** @jsx jsx */

import { jsx } from '@theme-ui/core';
var styles = {
  modalFooterContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderTop: 1,
    borderColor: 'grey.6',
    height: '68px',
    padding: 3
  }
};
var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children;
  return jsx("div", {
    sx: styles.modalFooterContainer
  }, children);
};
export { ModalFooter };